import { render } from "./TwoFAAnnouncementModal.vue?vue&type=template&id=8fb17348&scoped=true"
import script from "./TwoFAAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./TwoFAAnnouncementModal.vue?vue&type=script&lang=js"

import "./TwoFAAnnouncementModal.vue?vue&type=style&index=0&id=8fb17348&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb17348"]])

export default __exports__